export const AUTH_TYPES = {
  CPF: 2,
  PHONE: 1,
  CODE: 5
}
